import View from './view';
export const SurveyCongrats = View;
